import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/Axelerate_logo.svg'
import _imports_1 from '../../assets/Ilustration.png'
import _imports_2 from '../../assets/back_arrow.svg'


const _withScopeId = n => (_pushScopeId("data-v-14f16124"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "min-h-screen flex flex-col items-center justify-center rounded bg-background" }
const _hoisted_2 = { class: "flex flex-col bg-white lg:shadow-md px-4 sm:px-6 md:px-8 lg:px-10 py-8 rounded-lg w-full max-w-md" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pt-5 pb-5" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "login logo",
    class: "w-5/12 lg:pb-5"
  }),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    alt: "illustration",
    class: "w-5/12 lg:pb-5"
  })
], -1))
const _hoisted_4 = { class: "font-bold self-start text-xl sm:text-2xl text-gray" }
const _hoisted_5 = { class: "mt-5 mb-3 text-black text-sm overflow-clip tracking-normal text-left" }
const _hoisted_6 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_7 = { class: "flex flex-col mb-6" }
const _hoisted_8 = { class: "relative" }
const _hoisted_9 = { class: "flex w-full" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex w-full mt-8" }
const _hoisted_13 = {
  key: 0,
  class: "flex justify-center items-center mt-6 text-sm"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "arrow",
  class: "w-4 h-4"
}, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ml-3 items-center text-primary font-bold text-sm text-centerml-2" }, "Back to login", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.showConfirm ? "Email sent" : "Forgot your password?"), 1),
      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.showConfirm
            ? "Don't forget to check your inbox or spam folder"
            : "We will send you the instructions to recover your account"), 1),
      (!_ctx.showConfirm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("form", {
              onSubmit: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
            }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createVNode(_component_TextField, {
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event)),
                    label: "Email",
                    typeInput: "email",
                    rule: "required|email",
                    helperErrorText: "Email is required.",
                    name: "email"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("button", {
                  type: "submit",
                  disabled: !_ctx.meta.dirty || !_ctx.meta.valid,
                  class: "flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-primary rounded-full py-2 w-full transition duration-150 ease-in h-14 btn-submit"
                }, " Reset your password ", 8, _hoisted_10)
              ])
            ], 32)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("button", {
                type: "button",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.router.push('/log-in'))),
                class: "flex items-center justify-center focus:outline-none text-white text-sm sm:text-base bg-primary rounded-full py-2 w-full transition duration-150 ease-in h-14 btn-submit"
              }, " Go it ")
            ])
          ]))
    ]),
    (!_ctx.showConfirm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: "/log-in",
            class: "flex"
          }, {
            default: _withCtx(() => [
              _hoisted_14,
              _hoisted_15
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}